module.exports = __webpack_public_path__ + "media/icons/wlasciciel-prywatna-blue@3x-4d11f40c.svg";